function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M142.8,33.45c-4.8-4.8-12.5-4.8-17.3,0l-77.3,76.8l-27.3-27.5c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3l36,36.2 c2.4,2.4,5.5,3.6,8.7,3.6c3.1,0,6.2-1.2,8.6-3.6l86-85.5C147.5,45.95,147.6,38.25,142.8,33.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.2,187.45c-30.3,0-55,24.7-55,55s24.7,55,55,55s55-24.7,55-55C128.1,212.15,103.5,187.45,73.2,187.45z M73.2,272.95 L73.2,272.95c-16.8,0-30.5-13.7-30.5-30.5s13.7-30.5,30.5-30.5s30.5,13.7,30.5,30.5S90,272.95,73.2,272.95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.2,345.15c-30.3,0-55,24.7-55,55s24.7,55,55,55s55-24.7,55-55C128.1,369.75,103.5,345.15,73.2,345.15z M73.2,430.55 L73.2,430.55c-16.8,0-30.5-13.7-30.5-30.5s13.7-30.5,30.5-30.5s30.5,13.7,30.5,30.5C103.6,416.95,90,430.55,73.2,430.55z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.6,206.75H189c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h283.6c6.8,0,12.3-5.5,12.3-12.3 S479.4,206.75,472.6,206.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.6,253.65H189c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h283.6c6.8,0,12.3-5.5,12.3-12.3 S479.4,253.65,472.6,253.65z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189,388.85h283.6c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H189c-6.8,0-12.3,5.5-12.3,12.3S182.2,388.85,189,388.85z "
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.6,435.85c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H189c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3H472.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.8,61.35c0,6.8,5.5,12.3,12.3,12.3h283.6c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H189 C182.2,49.05,176.8,54.55,176.8,61.35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.6,96.05H189c-6.8,0-12.3,5.5-12.3,12.3c0,6.8,5.5,12.3,12.3,12.3h283.6c6.8,0,12.3-5.5,12.3-12.3 C484.9,101.55,479.4,96.05,472.6,96.05z"
}));

var SvgIconCheckoutForm = function SvgIconCheckoutForm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485",
    style: {
      enableBackground: "new 0 0 485 485"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckoutForm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_checkout-form.5b3ce0a5.svg";
export { ForwardRef as ReactComponent };